import { createRef, useEffect, useLayoutEffect, useState } from "react";

export function useWindowSize() {
    const isSSR = typeof window !== "undefined";
    const [windowSize, setWindowSize] = useState({
        width: isSSR ? 1200 : window.innerWidth,
        height: isSSR ? 800 : window.innerHeight,
    });

    function changeWindowSize() {
        setWindowSize({ width: window.innerWidth, height: window.innerHeight });
    }

    useEffect(() => {
        window.addEventListener("resize", changeWindowSize);
        return () => { window.removeEventListener("resize", changeWindowSize) };
    }, []);

    return windowSize;
}

export default function Measure({ children, setWidth, setHeight, setSize }) {
    // contains reference to the initial-render-dev (or null)
    const ref = createRef(null);
    // store the size in a state, so that it persists, even when the div is gone
    const [size, _setSize] = useState({ width: 0, height: 0 });

    // on (2nd) initial render, measure the size using the ref
    useLayoutEffect(() => {
        _setSize({ width: ref.current ? ref.current.offsetWidth : 0, height: ref.current ? ref.current.offsetHeight : 0 });
        // eslint-disable-next-line
    }, []);

    // whenever the size changes (only on 2nd render) run the callbacks
    useEffect(() => {
        if (setWidth) setWidth(size.width);
        if (setHeight) setHeight(size.height);
        if (setSize) setSize(size);
        // eslint-disable-next-line
    }, [size]);

    // wrap in referenced div to measure size on first render
    return ref.current ? children : (<div ref={ref}>{children}</div>); 
}
